import { ScreenerContext } from 'domains/signup/screener/context/screenerContext';

export const useScreenerProgress = (currentQuestionIndex: number): number => {
  const currentState = ScreenerContext.useSelector(state => state.value);
  const therapyScreener = ScreenerContext.useSelector(({ context }) => context.therapyScreener);

  // Calculate progress as a percentage of completed questions plus the initial steps
  // As an estimate, EnterTarget and EnterDob take up 20% of the progress while the questions make up 80% of the progress
  switch (currentState) {
    case 'enterTarget':
      return 10;
    case 'enterDob':
      return 20;
    case 'loadingScreener':
      return 20;
    case 'noScreenerFound':
      return 20;
    case 'runningScreenerQuestions': {
      let totalProgress = 20;

      const questions = therapyScreener?.fields?.questions;

      if (questions && questions.length > 0) {
        const questionProgress = ((currentQuestionIndex + 1) / questions.length) * 80;
        totalProgress += questionProgress;
      }

      return totalProgress;
    }
    case 'finished':
      return 100;
    default:
      return 0;
  }
};
